export enum GoogleAnalyticsCategory {
    Video = 'video',
    PageView = 'page_view',
}
